import { SVG } from "./svg";
import { Graph, GraphValue } from "./graph";
import { Size, Rect } from "./size";

export class Vertbars {

  static data_index = "data-index";
  static data_sub_index = "data-sub-index";
  static data_object_id = "data-object-id";

  static hoverBar(display_el: SVGElement, idx: number, sub_idx: number, amount: number, date: string, item_id: string, item_name: string) {
    const off_color = "#e4e4e4";
    const medium_color = "#7fdff9";
    const on_color = "#00C0F3";
    const amt_els = display_el.getElementsByClassName("vertbar-amount");
    const date_els = display_el.getElementsByClassName("vertbar-label");
    if (amt_els.length == 0 || date_els.length == 0) {
      return;
    }
    const amt_el = amt_els[0];
    const date_el = date_els[0];
    amt_el.innerHTML = Graph.compact_number(amount, 10000);
    const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
    title.innerHTML = Graph.formated_number(amount);
    amt_el.appendChild(title);
    const label_strs = [];
    if (date.length > 0) {
      label_strs.push(date);
    }
    if (item_name.length > 0) {
      label_strs.push(item_name);
    }
    date_el.innerHTML = label_strs.join(": ");
    const rects = display_el.querySelectorAll("rect.key_color_fill");
    if (item_id.length > 0) {
      for (let i = 0; i < rects.length; i++) {
        const rect = rects[i] as HTMLElement;
        rect.classList.remove("hover-off");
        rect.classList.remove("hover-on");
        rect.classList.remove("hover-medium");
        const data_id = rect.getAttribute(Vertbars.data_object_id);
        const data_idx = Number(rect.getAttribute(Vertbars.data_index));
        const data_sub_idx = Number(rect.getAttribute(Vertbars.data_sub_index));
        if (data_id != item_id) {
          rect.classList.add("hover-off");
          rect.style.fill = off_color;
        } else {
          if (data_idx == idx && data_sub_idx == sub_idx) {
            rect.classList.add("hover-on");
            rect.style.fill = on_color;
          } else {
            rect.classList.add("hover-medium");
            rect.style.fill = medium_color;
          }
        }
      }
    } else {
      for (let i = 0; i < rects.length; i++) {
        const rect = rects[i];
        rect.classList.remove("hover-off");
        rect.classList.remove("hover-on");
        rect.classList.remove("hover-medium");
      }
    }
  }

  static render(svg: SVGElement, id: string, title: string, data: GraphValue[][], bucket_labels: string[], color: string, inset: number = 12): Size {

    const show_scale = true;
    let scale_labels_width = 0;
    const max = Graph.totals(data);

    const header_height = 150;
    const graph_height = 150;
    const width = 400;
    const height = header_height + graph_height + (inset * 2);

    svg.setAttribute("viewBox", "0 0 " + width + " " + height + "");

    Graph.render_title(svg, id, title, width, inset);

    const number = document.createElementNS("http://www.w3.org/2000/svg", "text");
    number.setAttribute("x", inset.toString());
    number.setAttribute("y", "120");
    number.style.fontWeight = "bold";
    number.style.fontSize = "80px";
    number.style.letterSpacing = "-4px";
    number.style.fontFamily = SVG.font;
    number.setAttribute("fill", color);
    number.classList.add("vertbar-amount");
    svg.appendChild(number);

    const label = document.createElementNS("http://www.w3.org/2000/svg", "text");
    label.setAttribute("x", inset.toString());
    label.setAttribute("y", "145");
    label.style.fontSize = "12px";
    label.style.fontFamily = SVG.font;
    label.setAttribute("fill", "#373737");
    label.classList.add("vertbar-label");
    svg.appendChild(label);

    if (show_scale) {
      const r: Rect = {
        left: inset,
        top: height - graph_height - inset,
        width: width - inset - inset,
        height: graph_height,
      }
      const scale = Graph.render_y_scale(svg, r, max.max);
      scale_labels_width = scale.pixel_length;
      max.max = scale.max;
    }

    const graph_width = width - (inset * 2) - scale_labels_width;

    let bucket_width = graph_width / data.length;
    let gutter = bucket_width / 3;
    if (gutter > 6) {
      gutter = 6;
    }
    bucket_width = (graph_width - ((data.length - 1) * gutter)) / data.length;
    const step = bucket_width + gutter;
    const graph = document.createElementNS("http://www.w3.org/2000/svg", "g");
    graph.style.transform = "scaleY(-1) translate(" + inset + "px, -" + (height - inset) + "px)";
    svg.appendChild(graph);
    for (let i = 0; i < data.length; i++) {
      const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
      g.setAttribute("transform", "translate(" + (i * step) + ", 0)");
      const bg = SVG.rect(0, 0, bucket_width, graph_height, "vert_barchart_bg");
      bg.setAttribute("fill", "none");
      bg.onmouseenter = function () {
        let label = "";
        if (bucket_labels.length > i) {
          label = bucket_labels[i];
        }
        Vertbars.hoverBar(svg, i, 0, max.totals[i], label, "", "");
      }
      g.appendChild(bg);
      const base = SVG.rect(0, 0, bucket_width, 1, "vert_barchart_marker");
      base.setAttribute("fill", "#e2e2e2");
      g.appendChild(base);
      graph.appendChild(g);
      const entries = data[i];
      var offset = 0;
      for (let j = 0; j < entries.length; j++) {
        const entry = entries[j];
        const y = (offset / max.max) * graph_height;
        const h = (entry.amount / max.max) * graph_height;
        if (!isNaN(h) && h > 0) {
          const r = SVG.rect(0, y, bucket_width, h, "key_color_fill");
          r.setAttribute(Vertbars.data_object_id, entry.label);
          r.setAttribute(Vertbars.data_index, i.toString());
          r.setAttribute(Vertbars.data_sub_index, j.toString());
          r.setAttribute("fill", color);
          g.appendChild(r);
          r.onmouseenter = function () {
            let label = "";
            if (bucket_labels.length > i) {
              label = bucket_labels[i];
            }
            Vertbars.hoverBar(svg, i, j, entry.amount, label, entry.label, entry.label);
          }
        }
        if (!isNaN(y)) {
          const divider_h = 1 / window.devicePixelRatio;
          const edge = SVG.rect(0, y, bucket_width, divider_h, "vert_barchart_divider");
          edge.setAttribute("fill", "#fff");
          g.appendChild(edge);
        }
        offset += entry.amount;
      }
    }

    // set initial state
    const last_idx = max.totals.length - 1;
    if (last_idx >= 0) {
      let label = "";
      if (bucket_labels.length > last_idx) {
        label = bucket_labels[last_idx];
      }
      Vertbars.hoverBar(svg, 0, 0, max.totals[last_idx], label, "", "");
    }

    return {
      width: width,
      height: height,
    }
  }

}